import { useContext, useState, useEffect } from "react";
import { Box, Typography } from "@mui/material";
import heroImage from "../assets/home-hero2.jpg";
import { FiltersContext } from "../store/filters-options-context";
import StepperHome from "./Stepper";
import Footer from "./Footer";

export default function HomePage() {
    const { totalIndicators, dataSources, selectOptions, handleChange, handleRoute, params, valueSelected, mainCategory } = useContext(FiltersContext);

    const [active, setActive] = useState(false);

    useEffect(() => {
        setActive(
            params.domain_code !== "" ||
            (valueSelected.repositories &&
                valueSelected.repositories.label &&
                params.area !== "") ||
            mainCategory === "bulk"
        );
    }, [params.domain_code, valueSelected.repositories, params.area, mainCategory]);

    useEffect(() => {
        document.documentElement.classList.add("homepage");
        return () => {
            document.documentElement.classList.remove("homepage");
        };
    }, []);

    return (
        <>
            <Box
                sx={{
                    minHeight: {
                        xs: "100vh",
                        md: "100vh"
                    }
                }}
            >
                <Box
                    sx={(theme) => ({
                        flexDirection: { xs: "column", lg: "column" },
                        padding: "0 1.5vw",
                        alignItems: "center",
                        justifyContent: "flex-start",
                        height: "100%",
                        display: "flex",
                        "&:before": {
                            content: '""',
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            backgroundRepeat: "no-repeat",
                            backgroundSize: "cover",
                            backgroundPosition: "top center",
                            backgroundImage:
                                theme.palette.mode === "dark"
                                    ? `linear-gradient(to top,rgba(0,0,0,0) 0,rgba(0,0,0,.01) 1%, #000 120%), url(${heroImage})`
                                    : `linear-gradient(to bottom,rgba(255,255,255,0.5) 0,rgba(0,0,0,.01) 30%,#000 120%), url(${heroImage})`,
                            zIndex: -1,
                        },
                    })}
                >
                    <Typography
                        variant="h1"
                        sx={{
                            fontSize: { xs: 25, md: 35, lg: "3vw" },
                            mt: 3,
                            textAlign: "center",
                        }}
                    >
                        The State of Agrifood Systems <Typography component='span' sx={{ display: 'block' }} fontSize='smaller'>Data Platform</Typography>
                    </Typography>
                    <StepperHome
                        handleRoute={handleRoute}
                        handleChange={handleChange}
                        options={selectOptions}
                        active={active}
                    />
                </Box>
            </Box>
            {/* <Box sx={{backgroundColor: 'red'}}>indicators: {totalIndicators} - sources: {dataSources}</Box> */}
            <Footer />
        </>
    );
}

